(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rh-countdown"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rh-countdown')){customElements.define('rh-countdown',class extends HTMLElement{connectedCallback(){clearInterval(this.clock);const d=this.dataset.date||'',t=this.dataset.time||'';const valid=/^\d{4}-\d{2}-\d{2}$/.test(d)&&/^([01]\d|2[0-3]):[0-5]\d$/.test(t);this.end=valid?Date.parse(d+'T'+t+':00+08:00'):NaN;const calendarOK=Number.isFinite(this.end)&&new Date(this.end+28800000).toISOString().slice(0,10)===d;this.hidden=!calendarOK&&this.dataset.editor!=='true';this.digits=[...this.querySelectorAll('[data-digit]')];this.tick=()=>{const seconds=calendarOK?Math.max(0,Math.ceil((this.end-Date.now())/1000)):0;const values=[Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60];this.digits.forEach((el,i)=>{el.textContent=String(values[i]).padStart(2,'0')});if(seconds===0)clearInterval(this.clock)};this.tick();if(calendarOK&&this.end>Date.now())this.clock=setInterval(this.tick,1000)}disconnectedCallback(){clearInterval(this.clock)}})}
  } catch(e) { console.error(e); }
})();

})();
